






























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Message, MessageBox } from 'element-ui'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import { LoanResponse, LoanState } from '@/api/model/loan'
import $Api from '@api'
import { translate, DateTime } from '@/utils/filters'
import { finalize } from 'rxjs/operators'

const loanStateOption: { label: string; value: LoanState }[] = [
    {
        label: translate('loan.tableData.loanState.init'),
        value: LoanState.INIT
    },
    {
        label: translate('loan.tableData.loanState.lending'),
        value: LoanState.LENDING
    },
    {
        label: translate('loan.tableData.loanState.finish'),
        value: LoanState.FINISH
    },
    {
        label: translate('loan.tableData.loanState.writeoff'),
        value: LoanState.WRITEOFF
    },
    {
        label: translate('loan.tableData.loanState.cancel'),
        value: LoanState.CANCEL
    },
    {
        label: translate('loan.tableData.loanState.fail'),
        value: LoanState.FAIL
    },
    {
        label: translate('loan.tableData.loanState.refuse'),
        value: LoanState.REFUSE
    },
    {
        label: translate('loan.tableData.loanState.transaction'),
        value: LoanState.TRANSACTION
    }
]

@Component({
    components: {
        SearchForm,
        TableForm
    },
    filters: {
        transformLoanState(state: LoanState) {
            const item = loanStateOption.find(option => option.value === state)
            if (item) {
                return item.label
            }
            return state
        }
    }
})
export default class LoanComponent extends Vue {
    tableData: LoanResponse[] = []
    shouldTableLoading = false
    total = 0
    releaseTime = null
    searchForm: { [key: string]: any } = {
        current: 1,
        size: 10,
        cardNo: null,
        appName: null,
        cameraIdStr: null,
        state: null,
        startReleaseTime: null,
        endReleaseTime: null,
        phone: null,
        customerName: null
    }
    loanStateOption = loanStateOption
    loanState = LoanState
    defaultTime = ['00:00:00', '23:59:59']

    created(): void {
        const { phone = '' } = this.$route.query
        this.searchForm.phone = phone
        this.getData()
    }

    getData(pageQuery?: object): void {
        if (pageQuery) {
            Object.assign(this.searchForm, pageQuery)
        }
        this.shouldTableLoading = true
        $Api.loanService
            .queryLoanPage(this.searchForm)
            .pipe(
                finalize(() => {
                    this.shouldTableLoading = false
                })
            )
            .subscribe(data => {
                this.tableData = data.records
                this.total = data.total
            })
    }

    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getData()
    }

    onFormReset(): void {
        // The resetFields method (from SearchForm.vue) does not take effect on datePicker, need to reset manually
        this.releaseTime = null
    }

    cancelLoan(row: LoanResponse): void {
        MessageBox.confirm(translate('loan.confirm.cancelLoan'), translate('common.tip'), {
            confirmButtonText: translate('common.btn.confirm'),
            cancelButtonText: translate('common.btn.cancel'),
            type: 'warning'
        })
            .then(() => {
                $Api.loanService
                    .cancelLoan({
                        lid: row.lid
                    })
                    .subscribe(data => {
                        if (data === true) {
                            Message.success(translate('loan.cancelLoan.success'))
                        } else {
                        }
                    })
            })
            .catch(() => {})
    }

    viewLoanDetail(row: LoanResponse): void {
        const { lid } = row
        this.$router.push({ path: '/credit/loan/detail', query: { lid: String(lid) } })
    }

    viewRepaymentDetail({ cameraId }: LoanResponse): void {
        const query = { cameraId: String(cameraId), from: 'credit-loan-record' }
        this.$router.push({ path: '/credit/loan/result', query })
    }

    @Watch('releaseTime')
    onReleaseTimeChange(date: [Date, Date]): void {
        if (date === null) {
            this.searchForm.startReleaseTime = null
            this.searchForm.endReleaseTime = null
        } else {
            const [startReleaseTime, endReleaseTime] = date
            this.searchForm.startReleaseTime = startReleaseTime.getTime()
            this.searchForm.endReleaseTime = endReleaseTime.getTime()
        }
    }

    dateTime(time) {
        if (time) return DateTime(time)
        return ''
    }

    canViewRepaymentDetail(state: LoanState) {
        return (state === LoanState.LENDING || state === LoanState.FINISH || state === LoanState.WRITEOFF)
    }

    get country() {
        return (this.$store.state.auth.authInfo || {}).country
    }
}
